import { render, staticRenderFns } from "./FormPriceGift.vue?vue&type=template&id=169a823f&"
import script from "./FormPriceGift.vue?vue&type=script&lang=js&"
export * from "./FormPriceGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports